export default "__VITE_ASSET__DfvxB3Tk__"